<template>
    <div>

        <div>
            <div class="add_dormitory_div">
                <Button size="small" type="primary" class="" @click="click_add_dormitory(project_id)" style="font-size:13px">
                    <Icon type="ios-add-circle-outline" />&nbsp;添加员工宿舍
                </Button>

            </div>

            <div v-for="(item, i) in dormitory_list" :key="i" class="room_list">
                <div class="room_name2">
                    <div class="room_name">
                        <Tag color="primary">{{ item.people_number }}人间</Tag>
                        <span class="iconfont iconditu"></span>
                        <span class="address">{{ item.address }}</span>
                    </div>
                    <div class="room_option">
                        <Icon type="ios-create-outline" size="18" color="grey" style="margin-right:5px"
                            @click="update_editor(item)" />
                        <Icon color="red" @click="del_room(item)" size="18" type="md-close" />
                    </div>
                </div>

                <div class="bed_list">
                    <div v-for="(people_item, x) in item.people_list" :key="x" class="bed_card"  @click="click_empty_bed(people_item)">
                        <div class="people_icon">
                            <span
                                :class="people_item.status == 0 ? 'iconfont iconbed iconbed_color' : 'iconfont iconbed iconbed_color2'"></span>
                        </div>

                        <div v-if="people_item.status == 0" class="people_bed_name" >
                            空床位
                        </div>
                        <div v-else class="people_bed_name2">
                            <div>{{ people_item.name }}</div>
                            <!-- <div>入住时间:{{ people_item.check_in_time_fmt }}</div> -->
                            
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div v-if="dormitory_list.length == 0" class="zanwu">
            暂无房间,快去完善员工宿舍信息吧~
        </div>


        <Modal v-model="add_dormitory_show" title="添加宿舍房间" :mask-closable="false" :footer-hide="true" width="430">
            <div class="add_dormitory_div2">
                操作说明：如果项目没有宿舍，请点击【暂无宿舍】即可。
            </div>
            <div class="add_div">
                <span>员工宿舍地址：</span>
                <Input v-model="add_dormitory_item.address" placeholder="请输入宿舍地址准确至房间号" style="width: 300px" />
            </div>
            <div class="add_div">
                <span>房间最大人数：</span>
                <Input v-model="add_dormitory_item.people_number" placeholder="请输入数字"
                    style="width: 100px;margin-right:5px" /><span>人间</span>
            </div>
            <div class="add_room_btn">
                <Button type="warning" @click="click_zanwu_dormitory" style="margin-right:10px">暂无宿舍</Button>

                <Button type="primary" @click="click_add_room">确认添加房间</Button>
            </div>
        </Modal>

        <Modal v-model="update_dormitory_show" title="更新宿舍房间" :mask-closable="false" :footer-hide="true" width="430">
            <div class="add_div">
                <span>员工宿舍地址：</span>
                <Input v-model="update_dormitory_item.address" placeholder="请输入宿舍地址准确至房间号" style="width: 300px" />
            </div>
            <div class="add_div">
                <span>房间最大人数：</span>
                <Input v-model="update_dormitory_item.people_number" placeholder="请输入数字"
                    style="width: 100px;margin-right:5px" /><span>人间</span>
            </div>
            <div class="add_room_btn">
                <Button type="primary" @click="click_update_room">确认更新房间信息</Button>
            </div>

        </Modal>
    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
    name: 'project_dormitory',
    data() {
        return {
            project_id: '',
            dormitory_list: [],
            add_dormitory_show: false,
            add_dormitory_item: {
                'address': '',
                people_number: 4
            },
            update_dormitory_show: false,
            update_dormitory_item: {
                address: '',
                people_number: 4,
                dormitory_id: ''
            }
        }
    },
    methods: {

        update_editor(item) {
            console.log(item)
            this.update_dormitory_show = true
            this.update_dormitory_item.dormitory_id = item.dormitory_id
            this.update_dormitory_item.address = item.address
            this.update_dormitory_item.people_number = item.people_number
        },

        del_room(item) {
            var that = this
            this.$Modal.confirm({
                title: '提示',
                content: '<p>正在删除宿舍，是否继续？</p>',
                onOk: () => {
                    that.del_room_http(item)
                },
                onCancel: () => {

                }
            });
        },

        del_room_http(item) {
            var that = this;
            var obj = {
                dormitory_id: item.dormitory_id,
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/project_detail/dormitory/project_dormitory_del",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_dormitory()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },


        del_people(item) {
            var that = this;
            var obj = {
                dormitory_people_id: item.dormitory_people_id,
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/project_detail/dormitory/dormitory_people_del",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_dormitory()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        click_empty_bed(item) {
            console.log(item)
            var that =this
            if(item.status==0){
                this.$Message.info('请在花名册中为员工分配宿舍')
            }else{
                this.$Modal.confirm({
                    title: '入住信息',
                    closable:true,
                    content: `<div>员工姓名：${item.name}</div><div>身份证号：${item.idcard}<div>入住时间：${item.check_in_time_fmt}</div>`,
                    okText: '关闭对话框',
                    cancelText: '将该员工移出宿舍',
                    onCancel(){
                        console.log(7777)
                        that.del_people(item)
                    }
                });
            }
            
        },

        click_add_room() {
            var that = this;
            var obj = {
                project_id: this.project_id,
                address: this.add_dormitory_item.address,
                people_number: this.add_dormitory_item.people_number,

            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/project_detail/dormitory/project_dormitory_add",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_dormitory()
                        that.add_dormitory_show = false
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });

        },


        click_update_room() {
            var that = this;
            var obj = {
                dormitory_id: this.update_dormitory_item.dormitory_id,
                address: this.update_dormitory_item.address,
                people_number: this.update_dormitory_item.people_number,

            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/project_detail/dormitory/project_dormitory_update",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_dormitory()
                        that.update_dormitory_show = false
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });

        },

        click_add_dormitory(project_id) {
            
            if(project_id){
                this.project_id = project_id
            }
            this.add_dormitory_show = true
        },

        open(project_id) {
            this.project_id = project_id
            console.log('获取宿舍列表')
            console.log(project_id)
            this.get_dormitory()
        },

        click_zanwu_dormitory() {
            var that = this;
            var obj = {
                project_id: this.project_id,
                dormitory_status:2
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/project_detail/dormitory/project_dormitory_status_update",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.add_dormitory_show = false
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        get_dormitory() {
            console.log('获取宿舍列表2')
            var that = this;
            var obj = {
                project_id: this.project_id,
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/project_detail/dormitory/project_dormitory",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.dormitory_list = res.data.dormitory_list
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        get_dormitory_people() {
            console.log('获取宿舍列表2')
            var that = this;
            var obj = {
                project_id: this.project_id,
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/project_detail/dormitory/project_dormitory",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.dormitory_list = res.data.dormitory_list
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        }


    }
}
</script>

<style scoped>
.add_dormitory_div2{
    padding:5px 10px;
    margin-bottom:10px;
    font-size:13px;
    display: flex;
    justify-content: center;
    color:#898989;
    background-color: #eaf1ff;
}
.people_bed_name {
    font-size: 13px;
    text-align: center;
    width: 100%;
    color: #c0c0c0;
}

.people_bed_name2 {
    font-size: 13px;
    color: #0466dd;
    text-align: center;
    width: 100%;
}

.iconbed_color {
    font-size: 18px;
    color: #c0c0c0;
}

.iconbed_color2 {
    font-size: 18px;
    color: #33aa4b;
}

.iconbed {
    font-size: 18px;
}

.people_icon {
    width: 30px;
}

.room_name2 {
    display: flex;
    justify-content: space-between;
}

.room_option {
    display: flex;
    cursor: pointer;
    justify-content: flex-end;
}

.add_dormitory_div {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
}


.zanwu {
    font-size: 13px;
    display: flex;
    justify-content: center;
    margin-top: 50px;
}

.iconditu {
    font-size: 18px;
    margin: 0 1px 0 5px;
    color: red;
}

.bed_card {
    border-radius: 3px;
    padding: 10px;
    width: 130px;
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    margin: 10px 10px 0 0;
}

.bed_card:hover {
    cursor: pointer;
    border: 1px solid #0466dd
}

.bed_list {
    display: flex;
    flex-wrap: wrap;
}

.room_name {
    display: flex;
    align-items: center;
}

.address {
    font-size: 13px;
    color: #333;
}

.room_list {
    padding: 10px;
    border: 1px solid #eaeaea;
    border-radius: 5px;
    margin-bottom: 10px;
    box-shadow: 0 0 3px #f6f6f6;
}

.add_room_btn {
    display: flex;
    margin-top:20px;
    justify-content: flex-end;
}

.add_div {
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
}
</style>